import React, { Fragment } from 'react';
import { connect } from "react-redux";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import ButtonContent from '../ButtonContent';
import withAuth from '../../hocs/withAuth';

class ActionForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: props.isOpenFormModal,
            formData: {
                email: ''
            }
        }
    }

    onClose = () => this.setState({ show: false }, () => this.props.hideAddModal());

    render() {
        let { clientType, onChange, formData, newGroupName, onSave, actionType } = this.props;
        const { show } = this.state;
        let _id = formData._id;
        let clientId = formData.clientId;
        let emailInput;
        let text;
        text = (_id || clientId) ? `Edit ${actionType}` : `Add New ${actionType}`;
      
        return (
            <Modal
                className="modal show"
                open={show}
                onClose={this.onClose}
            >
                <div className="modalBody modal-content" style={{ width: 400, height: 300 }}>
                        <Fragment>
                            <ModalHeading
                                text={text}
                                closeModal={this.onClose}
                            />
                            <div className="modalContent">
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextField
                                            label={actionType}
                                            value={formData.title}
                                            name="title"
                                            margin="dense"
                                            variant="outlined"
                                            onChange={event => onChange(event, 'title')}
                                            inputProps={{maxLength: 60}}
                                        />
                                    </Grid>
                                </Grid>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={onSave}
                                >
                                    <ButtonContent
                                        text="Save"
                                        icon="chevron-right" />
                                </Button>
                            </div>
                        </Fragment>
                  </div>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(ActionForm));



// WEBPACK FOOTER //
// ./src/components/assignments/ActionForm.js